var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el_financial"},[_c('banner'),_c('div',{staticClass:"mrow rmt"},[_c('div',{staticClass:"wrapper"},[_c('sidebar'),_c('div',{staticClass:"mline"}),_c('hotspot'),_c('broadcast')],1)]),_c('resources')],1)}
var staticRenderFns = []

export { render, staticRenderFns }